import React from 'react';
import { NylasScheduling } from '@nylas/react';
const apiUrl = 'https://api.us.nylas.com';
export const SchedulingPage = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const configId = urlParams.get('config_id') || '';
    return (React.createElement("div", { className: "p-4" },
        React.createElement("div", { className: "mb-4" },
            React.createElement("a", { href: "/integrations/scheduling", className: "px-3 py-2 rounded-lg border border-blue-500 text-blue-600 hover:bg-blue-50" }, "Open Scheduler Editor")),
        React.createElement("div", { className: "border rounded-xl bg-white p-2" },
            React.createElement(NylasScheduling, { configurationId: configId, schedulerApiUrl: apiUrl }))));
};
export default SchedulingPage;
